import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import {
  ISalesReportDto,
  ISalesReportFormData,
  ReportsService
} from 'src/app/_services/reports.service';

@Injectable()
export class SalesReportFormDataResolve implements Resolve<ISalesReportFormData> {
  constructor(private _reportsService: ReportsService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<ISalesReportFormData> {
    const providerId = route.paramMap.get('providerId');
    return this._reportsService.getSalesReportFormData(providerId);
  }
}

@Injectable()
export class SalesReportResolve implements Resolve<ISalesReportDto> {
  constructor(private _reportsService: ReportsService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<ISalesReportDto> {
    const reportId = route.paramMap.get('reportId');
    return this._reportsService.getSalesReport(reportId);
  }
}
